export default __webpack_public_path__ + "b7f7ec7d8ed5b8df15a224fad612dfed.svg";